import Link from 'next/link';
import useSWR from 'swr';

import { requestService } from 'shared/utils/services/requestService';

interface ICollectionItemProps {
  slug: string;
}

const fetchData = (url) => requestService({ url, method: 'GET' });

export const CollectionItem = ({ slug }: ICollectionItemProps) => {
  const { data } = useSWR(
    `/web-api/v1/collections/${slug}?excludeProductTemplates=true`,
    fetchData,
  );

  if (!data) return null;

  return (
    <Link href={`/collections/${slug}`} data-qa="collection_link" prefetch={false}>
      {data?.title}
    </Link>
  );
};
